import { Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgxCrudService } from "src/app/lib/ngx-crud.service";
import { Marker } from "src/app/models/shared/marker.model";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MarkersService extends NgxCrudService<Marker, number> {
  constructor(
    protected http: HttpClient
  ) {
    super(http, { apiBaseUrl: environment.apiBaseUrl });
    this._baseUrl = environment.markersBaseUrl;
  }

  getLayers(tipologia?: any)  {
    return this.http.get<any[]>(this._baseUrl + 'layers/' + tipologia, {
      withCredentials: true,
    });
  }

  searchBounds(params: any): Observable<Marker[]> {
    return this.http.post<Marker[]>(this._baseUrl + 'search/bounds', params, {
      withCredentials: true,
    });
  }

}
